import dynamic from 'next/dynamic'
import { createContext, FC, useContext, useState } from 'react'

import { handleChunkLoadError } from '@/lib/errorHandler'

type LoginModalContext = {
  showModal: () => void
}

const Context = createContext({} as LoginModalContext)

export function useLoginModal() {
  return useContext(Context)
}

export const LoginModalProvider: FC = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false)

  const showModal = () => {
    setOpen(true)
  }

  return (
    <Context.Provider value={{ showModal }}>
      {children}
      <LoginModal open={open} onClose={() => setOpen(false)} />
    </Context.Provider>
  )
}

const LoginModal = dynamic<{ open: boolean; onClose: () => void }>(
  import('@/components/organisms/functionals/LoginModal')
    .then(m => m.LoginModal)
    .catch(async error => {
      await handleChunkLoadError(error)
      return () => null
    }),
  {
    ssr: false,
  }
)
